import i18n from '@/../i18n';
import { findIndex } from 'lodash';
import { ContactField, ContactFieldTypes, CustomField } from '@dev/ee-api/ee-api-models';
import { CUSTOM_FIELD_DEFAULT_FIELD_LENGTH } from '@/services/constants';
import { CustomFieldTypes } from '@/services/dictionaries/CustomFieldTypes';

export const validateCustomFieldName = (fieldName = '', collection: ContactField[]): string => {
    if (fieldName.length === 0) {
        //field name is empty
        return i18n.t('errornewfieldnameempty');
    }
    if (fieldName.indexOf(' ') > -1) {
        //field name cannot have white spaces
        return i18n.t('errornewfieldwhitespaces');
    }
    if (/^\d/.test(fieldName[0])) {
        //field name starts with digit
        return i18n.t('errornewfieldnamestartnumber');
    }
    if (/\W/g.test(fieldName)) {
        //non-word signs in field name
        return i18n.t('errornewfieldnovalid');
    }
    if (findIndex(collection, (item): boolean => item.Name === fieldName) > -1) {
        return i18n.t('duplicatefieldname'); //field with given name already exists
    }
    return null;
};

export const getDefaultCustomFieldSettings = (fieldType: string): CustomField => {
    if (fieldType === CustomFieldTypes.Birthday) {
        return {
            FieldType: ContactFieldTypes.DateTime,
            Length: 0,
            Name: i18n.t('name'),
        };
    }
    if (fieldType === CustomFieldTypes.Consent) {
        return {
            FieldType: ContactFieldTypes.Boolean,
            Length: 0,
            Name: i18n.t('name'),
        };
    }
    return {
        FieldType: ContactFieldTypes.Text,
        Length: CUSTOM_FIELD_DEFAULT_FIELD_LENGTH,
        Name: i18n.t('name'),
    };
};
